/* eslint-disable indent */
import styled from 'styled-components';

export const NavBarContainer = styled.div`
  background: #994878;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;
  padding: 12px;

  img {
    height: 40px;
  }
`;

export const Content = styled.div`
  max-width: 432px;
  padding: 24px 16px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  align-items: center;

  h1 {
    font-size: 21px;
    margin-bottom: 12px;
    color: #000000;
  }

  h2 {
    font-size: 14px;
    color: #5d5d5d;
    margin-bottom: 12px;
    margin-top: 10px;
  }

  h3 {
    color: #18233d;
    font-weight: 400;
    font-size: 18px;
    margin-bottom: 8px;
  }

  .greeting {
    color: #454444;
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 8px;
  }

  .firstLabel {
    color: #454444;
    font-weight: 600;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 8px;
    text-transform: capitalize;
  }

  .number {
    color: #994878;
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 8px;
    margin-left: 5px;
    margin-right: 5px;
  }

  .numbertwo {
    color: #18233d;
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 8px;
    margin-left: 5px;
  }

  .introduction {
    color: #919090;
    font-size: 14px;
    margin-bottom: 8px;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #f3f3f3;
  }

  .instructions {
    color: #676767;
    font-size: 16px;
    margin-bottom: 24px;
    font-weight: 600;
  }

  .input {
    margin-bottom: 24px;
    color: #979797;
  }

  .label-description {
    font-size: 12px;
    color: #5d5d5d;
    margin-bottom: 8px;
  }

  .accept-check span:last-child {
    font-weight: normal;
    color: #676767;
    font-size: 14px;
  }

  button span {
    text-transform: none;
    font-weight: bold;
  }

  .Mui-disabled {
    background-color: #f3f3f3;
  }

  .MuiInputBase-root.Mui-disabled {
    color: inherit;
  }

  .react-html5-camera-photo > img {
    width: 600px;
  }
`;

export const ContentButon = styled.div`
  max-width: 432px;
  padding: 10px 16px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

export const ContentButonGroup = styled.div`
  margin-top: 25px;
  width: 100%;
`;

export const ContainerCard = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  text-align: center;
`;

export const ContainerData = styled.div`
  display: flex;
`;

export const ContainerGeneral = styled.div`
  max-width: 100%;
`;

export const ContainerDialogTerms = styled.div`
  max-width: 100%;
  padding: 64px 16px;

  p {
    text-align: justify;
  }
`;

export const ButtonGrup = styled.div`
  margin-top: 25px;
  position: relative;
`;

export const ButtonGrupDialog = styled.div`
  margin-top: 25px;
  width: 100%;
  text-align: end;
  margin-bottom: 25px;
`;

export const ContentTerms = styled.div`
  width: 100%;
  margin-left: 20px;
  margin-top: 20px;
  text-align: center;
`;

export const ContentDialog = styled.div`
  max-width: 432px;
  padding: 5px 16px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  h1 {
    font-size: 20px;
    margin-bottom: 12px;
    color: #000000;
    margin-top: 60px;
    text-align: center;
  }

  h2 {
    font-size: 17px;
    margin-bottom: 12px;
    color: #666666;
    text-align: center;
  }
`;

export const ImageContainer = styled.div`
  border-radius: 3px;
  width: 100%;
  height: 220px;
  border: dashed 1px
    ${props => {
      // eslint-disable-next-line prettier/prettier
      if (props.onError) return 'red';
      // eslint-disable-next-line prettier/prettier
        return '#d5d5d5';
      // eslint-disable-next-line prettier/prettier
  }};
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  margin-top: 10px;
`;

export const DocumentContainer = styled.div`
  float: left;
  width: 100%;
  height: 100%;
`;

export const ImageDocumentContainer = styled.div`
  float: left;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover .distributor-image {
    opacity: 0.3;
  }

  &:hover .replace-buttom {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const DistributorImage = styled.img`
  display: block;
  width: auto;
  height: auto;
  max-width: 240px;
  max-height: 200px;
  margin: 0 auto;
  object-fit: contain;
`;

export const DocumentText = styled.div`
  float: left;
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #994878;
  margin-top: 5px;
`;

export const BeneficiosList = styled.ul`
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 12px 0;
  margin-bottom: 50px;
  list-style: none;

  li {
    position: relative;
    padding: 8px 0 8px 24px;
    font-size: 14px;
    color: #454444;
    border-bottom: 1px solid #f3f3f3;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #994878;
    }

    strong {
      color: #994878;
      font-weight: 600;
    }
  }

  li:last-child {
    border-bottom: none;
  }
`;
